import _ from 'underscore';
import $ from 'jquery';

/**
 * get popup editor position based on input position
 *
 * @param {Object} pos - the based position, can also be a func
 * @param {Object} popupEditor - popupEditor view
 * only needed when pos is a function
 *
 * @returns {Object} - {left,top, right, bottom} of calculated position
 */
export function getPosition(pos, popupEditor) {
  let position = pos;

  if (_.isFunction(pos)) {
    position = pos(popupEditor.$el);
  } else if (pos instanceof $) {
    position = pos.position();
  } else if (pos instanceof HTMLElement) {
    position = pos.getBoundingClientRect();
  }

  return _.pick(position, 'left', 'top', 'right', 'bottom');
}
